import styled from "styled-components";
import { SkeletonLine } from "../../Componentes/Utils/SkeletonLine";

const InfoContainer = styled.div`
    width: 100%;
    height: 41px;
    background-color: #FAFCFC;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 15px 0 12px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 11px;
    overflow-x: auto;
    white-space: nowrap;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

const TituloInfoContainer = styled.p`
    font-weight: bold;
    margin: 0;
    color: #ACAFB0;
`;

const TextInfoContainer = styled.p`
    font-weight: bold;
    margin: 0;
`;

const ContainerInfo = ({ title, value, loading }) => {
    return(
        <>
            <InfoContainer>
                {loading ? (
                    <>
                        <SkeletonLine style={{ height: "8px", width: "40%", margin: "2px 0" }} />
                        <SkeletonLine style={{ height: "12px", width: "70%", margin: "4px 0 0" }} />
                    </>
                ) : (
                    <>
                        <TituloInfoContainer>{ title }</TituloInfoContainer>
                        <TextInfoContainer>{ value }</TextInfoContainer>
                    </>
                )}
            </InfoContainer>
        </>
    )
}

export default ContainerInfo;